import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { playPause, updateColor } from '../../../redux/slices/visualSlice';

const InsertionSort = ({ countIterations }) => {
  const myState = useSelector(state => state.updateProps);
  const dispatch = useDispatch();
  const timeoutsRef = useRef([]);
  const cancelledRef = useRef(false);

  const clearAllTimeouts = () => {
    cancelledRef.current = true;
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
  };

  const schedule = (fn, delay) => {
    if (cancelledRef.current) return;
    const id = setTimeout(() => {
      if (!cancelledRef.current) fn();
    }, delay);
    timeoutsRef.current.push(id);
  };

  const solve = () => {
    const values = myState.values.map(item => item[0]);
    const ids = myState.values.map(item => item[1]);
    const speed = myState.speed;
    const color = myState.color;

    const valuesCopy = [...values];
    let total_time = 0;
    for (let i = 0; i < valuesCopy.length - 1; i++) {
      let j = i + 1;
      while (j > 0 && valuesCopy[j] < valuesCopy[j - 1]) {
        [valuesCopy[j], valuesCopy[j - 1]] = [valuesCopy[j - 1], valuesCopy[j]];
        total_time++;
        j--;
      }
    }

    let timer = 0;
    for (let i = 0; i < values.length - 1; i++) {
      let ind = i + 1;
      while (ind > 0 && values[ind] < values[ind - 1]) {
        const j = ind;
        [values[j], values[j - 1]] = [values[j - 1], values[j]];
        [ids[j], ids[j - 1]] = [ids[j - 1], ids[j]];
        const snapshotIds = [...ids];

        schedule(() => {
          countIterations(j);
          document.getElementById(snapshotIds[j]).style.transform = `translateX(${j * 11}px)`;
          document.getElementById(snapshotIds[j - 1]).childNodes[1].style.backgroundColor = 'black';
          schedule(() => {
            document.getElementById(snapshotIds[j - 1]).childNodes[1].style.backgroundColor = color;
          }, speed - 10);
          document.getElementById(snapshotIds[j - 1]).style.transform = `translateX(${(j - 1) * 11}px)`;
        }, timer * speed);

        timer++;
        ind--;
      }
    }

    schedule(() => {
      dispatch(playPause(false));
      dispatch(updateColor('rgb(0, 182, 0)'));
    }, (total_time + 1) * speed + 50);
  };

  useEffect(() => {
    if (myState.algorithm === 'insertion' && myState.play) {
      clearAllTimeouts();
      cancelledRef.current = false;
      solve();
    }
    return clearAllTimeouts;
  }, [myState.play]);

  useEffect(() => {
    return clearAllTimeouts;
  }, [myState.algorithm, myState.values]);

  return <></>;
};

export default InsertionSort;
